var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollArea",staticClass:"flex-grow-1 h-100",attrs:{"id":"main-page"}},[_c('alert-bar'),_c('breadcrumb',{staticClass:"mb-3"}),_c('div',{staticClass:"m-3"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('img',{staticClass:"icool-logo",attrs:{"alt":"icool logo","src":_vm.icoolLogo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }